module.exports = __webpack_public_path__ + "img/scene_bedtime_dw_backlight@2x.70eff7a5.png";